import { parseBlogSource, sortBlogPosts, type BlogPost } from "./blog";

const modules = import.meta.glob("../../content/blog/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

export const blogPosts: BlogPost[] = sortBlogPosts(
  Object.entries(modules).map(([file, raw]) => parseBlogSource(file, raw)),
);

export function blogPostBySlug(slug: string): BlogPost | undefined {
  return blogPosts.find((post) => post.slug === slug);
}
